/*eslint-disable*/export const messages=JSON.parse("{\"pill.aria.openFilter\":\"Open filter\",\"pill.aria.removeFilter\":[\"Remove filter \",[\"label\"]]}");